import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
    IPortfolioResultResponse
} from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';
import {IrbEditorPortfolioResultService} from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.service';
import {AuthService} from '@irb-common/services/auth.service';
import {DialogPrAuditDialogGridLayoutService} from "@irb/irb-dialogs/dialog-pr-audit/dialog-pr-audit-dialog.grid-layout.service";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import {IrbAgGridExportService} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';
import {ISecurityModelHistory} from '@irb/irb-editors/irb-editors.model';

@Component({ standalone: false,
    selector: 'irb-dialog-pr-audit',
    templateUrl: './dialog-pr-audit.component.html',
    styleUrls: ['./dialog-pr-audit.component.scss', '../../irb-common/styles/dialog.scss']
})
export class DialogPrAuditComponent implements OnInit {

    isLoading: boolean;
    showExport: boolean;
    pfSumryAuditDTOList: any[];
    grid: any;
    gridOptions: any;
    defaultGridHeights: {
        height: string,
        minHeight:string,
        maxHeight: string,
        domLayout:string
    };
    frameworkComponents: any;

    constructor(
        private dialogRef: MatDialogRef<DialogPrAuditComponent>,
        private portfolioService: IrbEditorPortfolioResultService,
        private authService: AuthService,
        private _http: HttpClient,
        private gls: DialogPrAuditDialogGridLayoutService,
        @Inject(MAT_DIALOG_DATA) public data: Partial<IPortfolioResultResponse>
    ) {
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.showExport = false;
        this.gridOptions = {
            columnDefs: this.gls.getColumnDefs(),            
            floatingFilter: false,
            overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
            context: { componentParent: this },
            suppressHorizontalScroll: true
        };
        
        this.frameworkComponents = this.gls.getFrameworkComponents();
        
        if (this.data) {
            this.computeGridHeights(0);
            this.portfolioService.getPortfolioResult({
                method: 'getPfSumryAuditTrailsReport',
                rebalId: this.data.rebalId,
                portfolioId: this.data.portfolioId
            }).subscribe((response: IPortfolioResultResponse) => {
                this.pfSumryAuditDTOList = response.pfSumryAuditDTOList || [];
                this.isLoading = false;
                if(this.pfSumryAuditDTOList && this.pfSumryAuditDTOList.length > 0) {
                    this.showExport = true;
                    this.computeGridHeights(this.pfSumryAuditDTOList.length);
                    this.pfSumryAuditDTOList.forEach((item: any) => {
                        item.modifiedDate = this.formatCreatedDate(item.modifiedDate);
                    });
                } else {
                    this.showExport = false;
                    this.computeGridHeights(0);
                }
            }, () => {
                this.isLoading = false;
            }, () => {
            });
        } else {
            this.pfSumryAuditDTOList = [];
            this.showExport = false;
        }

    }

    close() {
        this.dialogRef.close();
    }

    export() {
        this.getAuditTrail(this.data.rebalId + ',' + this.data.portfolioId).subscribe((res: any) => {
            const blob: any = new Blob([(res)], {type: 'text/csv'});
            const fileName: string = "auditTrail.csv";
            const data = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = data;
            link.download = fileName;
            link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));
        });
    }

    onGridReady(params: any) {
        this.grid = params;
    }

    computeGridHeights(totalRecords: number) {
        let defaultHeights: any;

        if(totalRecords <= 9 ) {
            defaultHeights ={
                height: null,
                minHeight:null,
                maxHeight: null,
                domLayout:'autoHeight'
            };
        } else {
            defaultHeights ={
                height: '330px',
                minHeight:'210px',
                maxHeight: '330px',
                domLayout:'normal'
            };
        }

        this.defaultGridHeights = defaultHeights;

        if(this.grid && this.grid.api ) {
            this.grid.api.setGridOption('domLayout', this.defaultGridHeights.domLayout);
        }
    }

    getAuditTrail(data: any): Observable<Object> {
        const headers = new HttpHeaders({
            "Content-Type": "application/json"
        });
        const p = {
            param: data
        };
        return this._http.post("/irebalone/export-audit-trail", JSON.stringify(p), { headers: headers, responseType: 'blob' });
    }
    formatCreatedDate(modifiedDate: any) {
        let dateArr = modifiedDate.split(" ");
        let datePart = dateArr[0].replace(/-/g, '/');
        let timePart = dateArr[1];
        let amPm: string = 'AM';
        let timeArr = timePart.split(":");
        let hour = timeArr[0];
        if (hour > 11 && hour < 24) {
            hour = hour - 12;
            amPm = "PM";
        }
        if (hour === 24) {
            hour = 12;
        }
        timeArr[0]=hour;
        return datePart + " "  + timeArr.join(":") + " " + amPm + " ET";
       }
}
